var v = { "version": "19.1.3", "branch": ""}; console.log("version:", v.version + " vc:" + v.branch);